import React from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import i18next from 'i18next';

import { BucketPieDataset } from 'stores/workflowStores/newWorkflowPlanStore/model/interfaces';
import portfolioColors from 'components/PortfolioTables/colors';

interface Props {
  data: any;
  title?: string;
  seriesName?: string;
  className?: string;
  smaller?: boolean;
}

export interface PieData {
  name: string;
  y: number;
  color: string;
}

const pie = (data: any): PieData[] | [] => {
  let pieData: PieData[] = [];

  const pieDataset = data;
  pieData = pieDataset.map(
    (set: BucketPieDataset): PieData => ({
      name: i18next.t(set.title),
      y: Math.round(set.share * 100),
      color: portfolioColors[set.code],
    }),
  );

  return pieData;
};

const BucketPieChart: React.FC<Props> = (props) => {
  const settings: Highcharts.Options = {
    chart: {
      type: 'pie',
      width: 330,
      height: props.smaller ? 160 : 260,
      margin: 30,
      animation: false,
      spacing: [0, 0, 0, 0],
    },
    credits: {
      enabled: false,
    },
    title: {
      text: props.title || '',
    },
    plotOptions: {
      series: {
        enableMouseTracking: false,
        animation: false,
      },
      pie: {
        allowPointSelect: true,
        dataLabels: {
          enabled: true,
          distance: 15,
          padding: 0,
        },
      },
    },
    series: [
      {
        name: props.seriesName || '',
        type: 'pie',
        data: pie(props.data),
        innerSize: '50%',
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={settings} className={props.className} />;
};

export default BucketPieChart;
